<template>
  <section class="container">
    <h1>Contact Us</h1>
    <div class="conts">
      <div class="left animate__animated animate__fadeInLeft">
        <h2>{{ info.company }}</h2>
        <div class="en">{{ info.eng_name }}</div>
        <ul>
          <li class="iconfont icon-a-Group23">{{ info.tel }}</li>
          <li class="iconfont icon-Vector">{{ info.email }}</li>
          <li class="iconfont icon-a-Group17">
            {{ info.address }}
          </li>
        </ul>
        <div class="code_box">
          <p>Scan the code to follow "Anhui Haima Intelligent"<br />Official WeChat official account</p>
          <div class="img">
            <img :src="$baseURL + info.wechat_qrcode" alt="" />
          </div>
        </div>
      </div>
      <div class="right animate__animated animate__fadeInRight">
        <iframe :src="$baseURL + '/map.html'" frameborder="0" width="100%" height="100%"></iframe>
      </div>
    </div>
  </section>
  <section class="message">
    <div class="container">
      <h1>MESSAGE</h1>
      <div class="from">
        <div class="row">
          <div class="from_item">
            <div class="label">Your title</div>
            <div class="input" :class="{ error: formData.name.bool }">
              <input ref="name" maxlength="10" type="text" v-model="formData.name.value" />
              <p class="err">{{ formData.name.msg }}</p>
            </div>
          </div>
          <div class="from_item">
            <div class="label">Your phone number</div>
            <div class="input" :class="{ error: formData.tel.bool }">
              <input ref="tel" type="tel" maxlength="15" v-model="formData.tel.value" />
              <p class="err">{{ formData.tel.msg }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="from_item">
            <div class="label">your e-mail</div>
            <div class="input" :class="{ error: formData.eamil.bool }">
              <input ref="eamil" type="email" v-model="formData.eamil.value" />
              <p class="err">{{ formData.eamil.msg }}</p>
            </div>
          </div>
          <div class="from_item">
            <div class="label">your company</div>
            <div class="input" :class="{ error: formData.company.bool }">
              <input ref="company" type="text" maxlength="20" v-model="formData.company.value" />
              <p class="err">{{ formData.company.msg }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="from_item">
            <div class="label">Consultation content</div>
            <div class="input" :class="{ error: formData.content.bool }">
              <textarea ref="content" rows="5" maxlength="200" v-model="formData.content.value"></textarea>
              <p class="err">{{ formData.content.msg }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="from_item submit_item">
            <div class="btn" @click="submit">submit</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="model" v-show="showModel">{{ modelMsg }}</div>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      modelMsg: "Submitted successfully!",
      showModel: false,
      map: "",
      formData: {
        name: { value: "", bool: false, msg: "Please enter your name!" },
        tel: { value: "", bool: false, msg: "Please enter your phone number!" },
        eamil: { value: "", bool: false, msg: "Please enter your email!" },
        company: { value: "", bool: false, msg: "Please enter your company name!" },
        content: { value: "", bool: false, msg: "Please enter the content you want to consult!" },
      },
      info: {
        address: "安徽省合肥市经开区天门路48-3号一楼",
        company: "安徽海玛智能科技有限公司",
        email: "bxd@inoma-ai.com",
        eng_name: "Anhui Haima Intelligent Technology co., ltd",
        tel: "0551-62657523",
        wechat_qrcode: "",
      },
    };
  },
  created() {
    this.contactContact();
  },
  methods: {
    async contactContact() {
      let res = await service.contactContact();
      this.info = res.data.info;
    },
    validateField() {
      for (let key in this.formData) {
        /* 判断有没有空值 */
        if (!this.formData[key].value) {
          switch (key) {
            case "name":
              this.formData[key].msg = "Please enter your name!";
              break;
            case "tel":
              this.formData[key].msg = "Please enter your phone number!";
              break;
            case "eamil":
              this.formData[key].msg = "Please enter your email!";
              break;
            case "company":
              this.formData[key].msg = "Please enter your company name!";
              break;
            case "content":
              this.formData[key].msg = "Please enter the content you want to consult!";
              break;
          }
          this.formData[key].bool = true;
        } else {
          this.formData[key].bool = false;
          /* 判断email格式 */
          if (key == "eamil") {
            var reg =
              /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
            if (!reg.test(this.formData[key].value)) {
              this.formData[key].msg = "Please enter the correct email address!";
              this.formData[key].bool = true;
            }
          }
          /* 判断tel格式 */
          if (key == "tel") {
            var reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
            if (!reg.test(this.formData[key].value)) {
              this.formData[key].msg = "Please enter the correct phone number!";
              this.formData[key].bool = true;
            }
          }
        }
      }
    },
    submit() {
      this.validateField();
      for (let key in this.formData) {
        if (this.formData[key].bool) {
          return;
        }
      }

      this.contactPostmsg();
    },
    async contactPostmsg() {
      let data = {};
      for (let k in this.formData) {
        data[k] = this.formData[k].value;
      }

      let res = await service.contactPostmsg(data);
      console.log(res);
      this.modelMsg = res.msg;
      this.modelMsgHeadle();
      if (res.code == 1) {
        for (let key in this.formData) {
          this.formData[key].value = "";
        }
      }
    },
    modelMsgHeadle() {
      this.showModel = true;
      setTimeout(() => {
        this.showModel = false;
      }, 2000);
    },
  },
};
</script>

<style lang="less" scoped>
.model {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 3px 5px;
  font-size: 14px;
  animation: op0 0.5s;
}

@keyframes op0 {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

h1 {
  font-size: 30px;
  margin-bottom: 30px;
}

.conts {
  display: flex;

  .left {
    width: 50%;
    background: var(--themeColor);
    padding: 60px 95px;
    color: #fff;
    box-sizing: border-box;

    h2 {
      font-size: 30px;
    }

    .en {
      font-size: 16px;
    }

    ul {
      margin: 40px auto 55px;

      li {
        font-family: Regular !important;
        font-size: 18px;
        display: flex;
        align-items: center;

        &::before {
          font-family: iconfont !important;
          font-size: 14px;
          margin-right: 20px;
          width: 25px;
          height: 25px;
          background: var(--themeColor2);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
        }

        &:nth-child(2) {
          &::before {
            font-size: 12px;
          }
        }

        &+li {
          margin-top: 30px;
        }
      }
    }

    .code_box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        font-size: 16px;
      }

      .img {
        width: 30%;

        img {
          width: 100%;
        }
      }
    }
  }

  .right {
    flex: 1;
  }
}

.message {
  background: #f9fbfd;
  padding: 110px 0;
  margin: 0 auto;

  .from {
    .row {
      display: flex;
      justify-content: space-between;

      &+.row {
        margin-top: 25px;
      }

      .from_item {
        flex: 1;

        .label {
          width: max-content;
          margin-bottom: 10px;
          font-size: 16px;
          position: relative;

          &::before {
            content: "*";
            color: #f00;
            position: absolute;
            top: 0;
            right: -10px;
          }
        }

        .input {

          input,
          textarea {
            width: 100%;
            box-sizing: border-box;
            background: #fff;
            border: 1px solid #eee;
            font-size: 16px;
            padding: 15px;
            border-radius: 8px;

            &:focus {
              border-color: var(--themeColor);
            }
          }

          .err {
            font-size: 12px;
            color: red;
            transition: all 0.3s;
            transform: translateY(10px);
            opacity: 0;
          }

          &.error input,
          &.error textarea {
            border-color: red;
          }

          &.error .err {
            transform: none;
            opacity: 1;
          }
        }

        &:first-child:not(:last-child) {
          margin-right: 30px;
        }

        &:last-child:not(:first-child) {
          margin-left: 30px;
        }

        &.submit_item {
          .btn {
            background: var(--themeColor2);
            width: max-content;
            margin: auto;
            color: #fff;
            padding: 15px 65px;
            border-radius: 40px;
            cursor: pointer;
            transition: all 0.3s;

            &:active {
              background: #d38900;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .conts {
    .left {
      padding: 30px;
    }
  }
}

@media (max-width: 800px) {
  .conts {
    display: block;

    .right {
      height: 92vw;
    }
  }

  .message {
    .from {
      .row {
        display: block;

        .from_item {
          &:first-child:not(:last-child) {
            margin-right: 0;
          }

          &:last-child:not(:first-child) {
            margin-left: 0;
          }
        }
      }
    }
  }
}

@media (max-width: 450px) {
  .conts {
    .left {
      h2 {
        font-size: 22px;
      }
    }
  }
}
</style>